// Utils
import { fetchText } from 'utils/fetch';
import { stringToNode } from 'utils/node';

// Constants
export const SHOPIFY_RELATED = 'related';
export const SHOPIFY_COMPLEMENTARY = 'complementary';

const createShopifyRecommendationsEngine = ({ sectionId, limit, itemQuery }) => {
  const recommendationEndpoint = window.theme.endpoints.productRecommendations;

  const query = async (intent, items) => {
    const productId = items[0].product_id || items[0].id;
    const url = `${recommendationEndpoint}?section_id=${sectionId}&product_id=${productId}&limit=${limit}&intent=${intent}`;

    try {
      const text = await fetchText(url, { method: 'GET' });

      return Promise.resolve(...stringToNode(text, [itemQuery]));
    } catch (err) {
      return Promise.reject(err);
    }
  };

  return { query };
};

export default createShopifyRecommendationsEngine;
